import { __awaiter } from "tslib";
import { isLocalHost } from 'utils/env';
import getSessionId from 'utils/getSessionId';
import getCurrentUserId from 'pathfinder/utils/getCurrentUserId';
import { isThemeDark } from 'utils/getWikiInfo';
function retrieveAffiliateUnitMetadata() {
    return __awaiter(this, void 0, void 0, function* () {
        const { cityId, articleId } = yield retrieveCommunityIdAndPageId();
        const userId = yield getCurrentUserId();
        const sessionId = getSessionId();
        const isDarkTheme = yield isThemeDark();
        return {
            cityId,
            articleId,
            userId,
            sessionId,
            isDarkTheme,
        };
    });
}
function retrieveCommunityIdAndPageId() {
    return __awaiter(this, void 0, void 0, function* () {
        const localContext = window.SilverSurferSDK.getContext().current;
        if (!(localContext === null || localContext === void 0 ? void 0 : localContext.productId) || !(localContext === null || localContext === void 0 ? void 0 : localContext.pageId)) {
            return { cityId: 0, articleId: 0 };
        }
        /* For debugging purposes, set these as variables, and during localhost testing,
         * inject a known cityId and articleId that will resolve from the dev fandom service */
        let cityId = parseInt(localContext.productId, 10);
        let articleId = parseInt(localContext.pageId, 10);
        if (isLocalHost()) {
            cityId = 147;
            articleId = 452217;
        }
        return {
            cityId,
            articleId,
        };
    });
}
export { retrieveAffiliateUnitMetadata };
